<template>
    <div class="content-wrap content-wrap--bigger" :class="{'is-loading' : isLoading}" id="kontakte">
        <kapp-header id="mainHeader"></kapp-header>
        <template v-if="! error && ! isLoading">
            <ul class="list list--filter"
                v-hammer:pan="scrollTo"
                v-hammer:panend="allowScroll">
                <li @click="scrollToDirect( 'favorites' )"
                    v-if="favList.length"
                    class="list-item list-item--favorites"><i class="icon-stern"></i></li>
                <li @click="scrollToDirect(char)" class="list-item" v-for="(char ,key) in alphabet"
                    :disabled="char.disabled" v-bind:key="key">{{char.char}}
                </li>
                <li @click="scrollToDirect('#')" disabled class="list-item">#</li>
            </ul>

            <ul class="list list--contact">
                <template v-if="favList.length">
                    <li class="list-item list-item--header" id="favorites">Favoriten</li>
                    <li class="list-item " v-for="(contact,idx) in favList" :key="'fav-' + idx">
                        <contact-box :contact="contact" />
                    </li>
                </template>
                <template v-for="(group,key) in contactsList" v-if="key !== 'favorites'">
                    <li class="list-item list-item--header" :id="key" :key="'header-' + key">{{key}}</li>
                    <li class="list-item " v-for="(contact,idx) in group" :key="key + idx">
                        <contact-box :contact="contact" />
                    </li>
                </template>
            </ul>

            <ul class="list list--contact list--search_results" v-if="filteredContacts">
                <li class="list-item " v-for="(contact,idx) in filteredContacts" v-bind:key="'foundContact-' + idx">
                    <contact-box :contact="contact" />
                </li>
            </ul>
        </template>
        <div v-else-if="error && ! isLoading">
            <p class="message message--error">{{error}}</p>
        </div>
        <overlay />
    </div>
</template>

<script>
	import api, { ApiDefaults } from '../utils/api_call';
	import ContactBox from "../components/subparts/ContactBox";
	import Overlay from "../components/subparts/Overlay";
	import Header from "../components/layouts/Header";
	import _ from 'lodash';

	export default {
		name: "KappKontakte",
		data() {
			return {
				alphas: _.range(65, 91),
				fullTextFilter: '',
				contacts: [],
				isLoading: true,
                error : false
			};
		},
		components: {
			'contact-box': ContactBox,
			'overlay': Overlay,
			'kapp-header': Header
		},
		directives: {},
		methods: {
			allowScroll: function ( evt ) {
				this.$el.style.overflow = 'auto';
			},
			scrollTo: function ( evt ) {
				this.$el.style.overflow = 'hidden';
				let scrollTarget = document.elementFromPoint(window.innerWidth - 15, evt.center.y);

				if ( scrollTarget.innerText != '#' && scrollTarget.getAttribute('disabled') === null ) {
					let el = document.querySelector('.list-item--header#' + scrollTarget.innerText.toUpperCase());
					document.querySelector('.content-wrap').scrollTop = (el.offsetTop - 82);
				}
			},

			scrollToDirect: function ( scrollTarget ) {

				if ( scrollTarget !== 'favorites' ) {
					scrollTarget = scrollTarget.char;
				}

				this.$scrollTo('.list-item--header#' + scrollTarget, 25, {
					offset: -82,
					container: '.content-wrap'
				});

			},

			fetchData: function () {

				let apiParams = Object.assign({}, ApiDefaults, {params: {id: 12}});

				api(apiParams)
					.then(( response ) => {
						if ( response.status === 200  ) {
							let contacts = response.data.user;

							contacts.map(( a ) => {
								a.username = '';
								a.open = false;
								return a;
							});

							contacts = contacts.sort(( a, b ) => {
								if ( a.lastName === b.lastName ) {
									return a.firstName.localeCompare(b.firstName);
								}
								return a.lastName.localeCompare(b.lastName);
							});

							this.contacts = contacts;
						}
					})
					.catch(( err ) => {
						this.error = 'Leider ist ein Fehler beim Laden aufgetreten!';
						console.warn(err);
					})
					.finally(() => {
						this.isLoading = false;
					});
			}
		},
		computed: {
			alphabet: function () {
				let contacts = this.contactsList;
				return _.map(this.alphas, function ( a ) {
					let isDisabled = !contacts.hasOwnProperty(String.fromCodePoint(a).toUpperCase());
					return {char: String.fromCodePoint(a), disabled: isDisabled};
				}.bind(contacts));
			},

			favList: function () {
				let list = this.contactsList;
				return list.favorites || [];
			},

			contactsList: function () {
				let contacts = _.groupBy(this.contacts, ( item ) => {
					if ( this.$store.getters.isFavorite({group: 'contacts', uid: item.uid}) ) {
						return 'favorites';
					}
					return item.lastName.charAt(0);
				});

				return contacts;
			},

			filteredContacts: function () {

				if ( this.fullTextFilter.toString().length > 2 ) {
					return this.contacts
					           .filter(
						           cont => (cont.firstName + ' ' + cont.lastName)
							           .toLowerCase()
							           .includes(this.fullTextFilter.toLowerCase())
					           );
				}

				return false;
			}
		},
		created() {
			this.fetchData();
			Events.$on('closeSearch', () => this.fullTextFilter = '');
			Events.$on('overlay:closed', () => this.fullTextFilter = '');
			Events.$on('fullTextSearch', ( val ) => this.fullTextFilter = val);

		},
        mounted() {
	        this.$store.watch(
		        ( state, getters ) => getters.barometerSubmitted,
		        ( newVal ) => {
			        this.submitted = !!(newVal);
		        }
	        );
        }
	};
</script>

<style scoped>
    #kontakte {

    }

    #kontakte::after {
        content: '';
        clear: both;
        display: table;
    }

    .list.list--filter {
        text-align: center;
        float: right;
        position: fixed;
        z-index: 100;
        top: 50%;
        right: 0;
        width: 30px;
        padding: 0;
        transform: translateY(-50%);
        max-height: 80vh;
        max-height: calc(100vh - 120px);
    }

    .list.list--filter .list-item[disabled] {
        color: #A1AAB3;
        opacity: .7;
    }

    .list.list--filter .list-item {
        color: #FFF;
        cursor: pointer;
        margin-top: 0;
        text-transform: uppercase;
        font-size: 10px;
        line-height: 17px;
        font-weight: 600;
    }

    .list.list--filter .list-item a {
        text-decoration: none;
    }

    .app--light .list.list--filter .list-item {
        color: #394452;
    }

    /*.app--light .list.list--filter .list-item.list-item--favorites,*/
    .list.list--filter .list-item.list-item--favorites {
        color: #FCC326;
    }


    .list.list--contact {
        margin-bottom: 60px;
    }

    .list.list--contact .list-item.list-item--header {
        font-size: 18px;
        margin-bottom: 10px;
        font-weight: bold;
        color: #FFF;
    }

    .list.list--contact .list-item.list-item--header:first-child {
        margin-top: 0;
    }

    .list.list--contact .list-item + .list-item {
        margin-top: 5px;
    }

    .list.list--contact .list-item + .list-item.list-item--header {
        margin-top: 30px;
    }

    .list.list--contact.list--search_results {
        position: fixed;
        top: 107px;
        left: 30px;
        right: 30px;
        z-index: 500;
        width: calc(100% - 60px);
        overflow: auto;
        margin: 0 auto;
        max-height: calc(100% - 107px);
    }


    .app--light .list.list--contact .list-item.list-item--header {
        color: #394452;
    }
</style>



// WEBPACK FOOTER //
// src/pages/KappKontakte.vue